import React, { useState } from 'react'
import Modal from '../../../../common/modal'
import { connect } from 'react-redux'
import { Button, Stack } from '@mui/material'
import { Item } from '../../../../common/snippets'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import Lineinput from '../../../../common/lineinput'
import InfoIcon from '@mui/icons-material/Info'
import { useTranslation } from '../../../../../i18n/I18nProvider'

const PartySaveEditOtpModal = (props) => {
    const { updateModal,
        dataValues: { headerText, otpInfo, resendOTP, updateValidatedIcon, saveApi,
            getTableData } } = props
    const [otp, setOtp] = useState('');
    const [error, setError] = useState(false);
    const { translations } = useTranslation()
    const gs = translations?.generalSettings || {}
    const tr = (key, fallback) => gs?.[key] || fallback
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
    const handleSubmit = () => {
        if (otp === otpInfo) {
            setError(false);
            saveApi()
            updateModal()
        } else {
            setError(true);
        }
    };
    const handleOTP = () => {

    }
    return (
        <>
            <Modal
                headTxt={headerText}
                width={'30%'}
                updateModal={updateModal}
                closeId={"closeButton"}
                modalClass={'booking-popup'}
                modalStyle={modalStyle}
            >
                <Stack style={{ display: 'flex', flexDirection: 'column', padding: '16px 16px', gap: '16px', justifyContent: 'center' }}>
                    <div style={{ fontFamily: 'Roboto', fontSize: '14px', fontWeight: '500', textAlign: 'center', color: '#444444' }}>
                       {tr('otpSentForVerification', 'OTP Sent For Verification.')}
                    </div>
                    <Item className="input--wrapper" sx={sx.itemsx}>
                        <Lineinput
                            id='mblNoOtp'
                            autoFocus
                            sx={{ width: '100%', fontSize: '14px', fontFamily: 'Roboto', fontWeight: '400', borderColor: error ? 'red' : '' }}
                            label={tr('enterOtp', 'Enter OTP')}
                            value={otp}
                            onChange={(e) => { setOtp(e.target.value); setError(false) }}
                            isError={error}
                            onBlur={(e) => handleOTP}
                        />
                    </Item>
                    {error && (
                        <div style={{ display: 'flex', alignItems: 'center', color: '#F05924', fontSize: '14px', fontWeight: 400 }}>
                            <InfoIcon style={{ fontSize: '15px', marginRight: '4px' }} />
                            {tr('wrongOtpEntered', 'Wrong OTP Entered')}
                        </div>
                    )}
                    <div style={{ fontFamily: 'Roboto', fontSize: '14px', fontWeight: '500', textAlign: 'center', color: '#0086FF', textDecoration: 'Underline', cursor: 'pointer' }}
                        onClick={() => { setError(false); setOtp(''); resendOTP() }}
                    >
                        {tr('resendOtp', 'Resend OTP')}
                    </div>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                        <Button
                            id="abtAddBtn"
                            style={{ margin: '0px 0px 0px 5px', height: "40px", width: '60%' }}
                            className="btn add-btn"
                            variant="contained"
                            color="error"
                            onClick={() => handleSubmit()}
                        >
                            {tr('submit', 'Submit')}
                        </Button>
                    </div>

                </Stack>
            </Modal>
        </>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
}
export default connect(mapStateToProps, mapDispatchToProps)(PartySaveEditOtpModal)
